import { Injectable } from '@angular/core';

import { ContactShowComponent } from '../../components/contacts/contact-show/contact-show.component';
import { ContactSidebarComponent } from '../../components/contacts/contact-sidebar/contact-sidebar.component';

@Injectable({
  providedIn: 'root',
})
export class ContactStoreService {
  contactShowComponent: ContactShowComponent;
  contactSidebarComponent: ContactSidebarComponent;

  constructor() {}
}
